<template>
  <div class="custom-control custom-checkbox">
    <input
      :id="id"
      :name="id"
      :checked="value ? 'checked' : ''"
      :disabled="disabled"
      type="checkbox"
      class="custom-control-input"
      @input="toggleValue()">
    <label
      v-t="label"
      :for="id"
      class="custom-control-label text-muted font-weight-bold"/>
  </div>
</template>

<script>
import generateId from '@/helpers/components/generateId';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: generateId(),
    };
  },
  methods: {
    toggleValue() {
      if (this.disabled !== true) {
        this.$emit('input', !this.value);
      }
    },
  },
};
</script>
